import { ArrowLeft } from "lucide-react";
import { Logo } from "@/components/Logo";

export default function PaymentCancel() {
    return (
        <div
            data-testid="payment-cancel-page"
            className="min-h-screen flex items-center justify-center px-5 py-16"
        >
            <div className="w-full max-w-xl bg-[#101010] border border-[#262626] rounded-[2rem] p-10 md:p-14 text-center shadow-[0_25px_60px_-25px_rgba(0,0,0,0.6)]">
                <div className="flex justify-center mb-8">
                    <Logo />
                </div>
                <p className="font-hand text-4xl text-[#D3A0A7]">no worries ♡</p>
                <h1 className="mt-4 font-serif-ed text-3xl md:text-4xl text-[#F1F1EF]">
                    Nothing was charged.
                </h1>
                <p className="mt-4 text-[#A9A6A0] text-sm leading-relaxed max-w-sm mx-auto">
                    The packages are waiting whenever you&apos;re ready — or book a
                    free call first and we&apos;ll figure it out together.
                </p>
                <a
                    href="/#packages"
                    data-testid="cancel-back-link"
                    className="group mt-8 inline-flex items-center gap-2 bg-[#0C0C0C] text-[#F1F1EF] font-semibold text-sm px-7 py-3.5 rounded-full hover:bg-[#D3A0A7] transition-colors duration-300"
                >
                    <ArrowLeft size={16} />
                    Back to Packages
                </a>
            </div>
        </div>
    );
}
